import request from '@/axios'

export function role_list () {
  return request({
    url: '/role/list_role/50',
    method: 'GET'
  })
}

export function user_list (schoolId, query) {
  return request({
    url: `/operationalUser/list/${schoolId}?${query.limit}?page=${query.page}`,
    method: 'GET'
  })
}

export function create_user (school_id, query) {
  return request({
    url: `/operationalUser/create/${school_id}`,
    method: 'POST',
    data: query
  })
}

export function edit_user (operations_user_id) {
  return request({
    url: `/operationalUser/show/${operations_user_id}`,
    method: 'GET'
  })
}


export function update_user (operations_user_id, query) {
  return request({
    url:`operationalUser/inlineEdit/${operations_user_id}`,
    method: 'POST',
    data: query
  })
}

export function delete_users (payload) {
  return request({
    url: '/operationalUser/delete',
    method: 'POST',
    data: payload
  })
}

// =>get

export function shortStudentListApi (customer_id) {
  return request({
    url:`clientUser/list/short/${customer_id}`,
    method:'GET'

  })
}

export function studentListFromStudentProfile (customer_id, client_user_id, page, payload) {
  return request({
    url:`clientUser/teachers/${customer_id}/${client_user_id}?page=${page}`,
    method:'POST',
    data: payload
  })
}

export function courseByTeacher (customer_id, client_user_id, page, payload) {
  return request({
    url:`clientUser/teachers_course/family/${customer_id}/${client_user_id}?page=${page}`,
    method:'POST',
    data: payload
  })
}

export function SinglefileUploadApi (payload) {
  return request({
    url: 'clientUser/file/create',
    method: 'POST',
    data:payload
  })
}

export function SinglefileDeleApi (payload) {
  return request({
    url: 'clientUser/file/delete',
    method: 'DELETE',
    data:payload
  })
}
